module.exports = __webpack_public_path__ + "img/alearnB_thumb.e7cea047.jpg";